import React from "react";
import {
    Box,
    Drawer,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Typography,
    Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
    Map,
    Info,
    Place,
    Hotel,
    Restaurant,
    ShoppingBag,
    LocalOffer,
    Image,
    VideoLibrary,
    Translate,
    LocalGasStation,
    DirectionsBus,
    AltRoute,
    Panorama,
    Insights,
    PhotoLibrary,
    LocationCity,
    PostAdd,
    EditNote,
    Route,
    AddLocationAlt,
    Tune,
    Logout,
} from "@mui/icons-material";
import logo from "../../component/logo/icon_new.png";
import { useNavigate, Link } from "react-router-dom";
import { logout } from "../auth";
import { GREEN, LIGHT } from "./AdminPageLayout";
const drawerWidth = 300;

// ใช้เพื่อแสดงสถานะเมนูที่กำลังเปิดอยู่เท่านั้น (ต้องตรงกับ handleSelect ใน MainAdmin)
const KEY_PATH = {
    addRouteDistrictName: "/admin/add/district",
    addRouteDistrictVideo: "/admin/add/districtvideo",
    addLanguage: "/admin/add/addLanguage",
    addFuel: "/admin/add/addFuel",
    addtravelDataWithVehicles: "/admin/add/addtravelDataWithVehicles",
    editimagesandvdo: "/admin/edit/editimagesandvdo",
    editimagebranner: "/admin/edit/editimagebranner",
    editimageinfographic: "/admin/edit/editimageinfographic",
    editimagedetailplace: "/admin/edit/editimagedetailplace",
    addRouteName: "/admin/add/route/route_name",
    addRouteMap: "/admin/add/route/addroutemap",
    addRouteDetail: "/admin/add/route/addroutedetails",
    touristPlace: "/admin/add/place/tourist_attraction",
    homestay: "/admin/add/place/hotel",
    restaurant: "/admin/add/place/restaurant",
    gift_shop: "/admin/add/place/gift_shop",
    communityProduct: "/admin/add/place/community_product",
    addTravelType: "/admin/add/form/addtraveltype",
};

const groupSx = {
    bgcolor: "transparent",
    boxShadow: "none",
    "&:before": { display: "none" },
    "&.Mui-expanded": { m: 0 },
};

const groupSummarySx = {
    minHeight: 40,
    px: 1.5,
    "&.Mui-expanded": { minHeight: 40 },
    "& .MuiAccordionSummary-content": { my: 1, alignItems: "center", gap: 1 },
    "& .MuiAccordionSummary-content.Mui-expanded": { my: 1 },
};

function GroupHeader({ icon, label }) {
    return (
        <>
            <Box sx={{ color: GREEN, display: "flex", "& svg": { fontSize: 18 } }}>{icon}</Box>
            <Typography
                sx={{
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: 0.5,
                    textTransform: "uppercase",
                    color: "text.secondary",
                    lineHeight: 1.3,
                }}
            >
                {label}
            </Typography>
        </>
    );
}

function AdminSideBar({ selected, onSelect, currentPath }) {
    const navigate = useNavigate();
    const role = localStorage.getItem("role");
    const handleLogout = () => {
        logout();
        sessionStorage.clear();
        navigate("/");
    };

    const Item = ({ itemKey, icon, label }) => {
        const active = currentPath === KEY_PATH[itemKey];
        return (
            <ListItemButton
                onClick={() => onSelect(itemKey)}
                selected={active}
                sx={{
                    position: "relative",
                    borderRadius: 2,
                    mb: 0.5,
                    py: 0.9,
                    pl: 1.5,
                    color: "text.primary",
                    "&:hover": { bgcolor: LIGHT },
                    "&.Mui-selected, &.Mui-selected:hover": { bgcolor: LIGHT, color: GREEN },
                    "&.Mui-selected::before": {
                        content: '""',
                        position: "absolute",
                        left: 0,
                        top: 8,
                        bottom: 8,
                        width: 4,
                        borderRadius: 4,
                        bgcolor: GREEN,
                    },
                }}
            >
                <ListItemIcon sx={{ minWidth: 36, color: active ? GREEN : "#689f38", "& svg": { fontSize: 20 } }}>
                    {icon}
                </ListItemIcon>
                <ListItemText
                    primary={label}
                    primaryTypographyProps={{
                        fontSize: 14,
                        lineHeight: 1.35,
                        fontWeight: active ? 700 : 500,
                        sx: { whiteSpace: "normal", wordBreak: "break-word" },
                    }}
                />
            </ListItemButton>
        );
    };

    return (
        <Drawer
            variant="permanent"
            anchor="left"
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                "& .MuiDrawer-paper": {
                    width: drawerWidth,
                    boxSizing: "border-box",
                    bgcolor: "#ffffff",
                    color: "text.primary",
                    borderRight: "1px solid #e6eee0",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                },
            }}
        >

            {/* โลโก้ด้านบน */}
            <Box sx={{ display: "flex", flexDirection: "column", minHeight: 0, flex: 1 }}>
                <Box
                    sx={{
                        px: 3,
                        py: 2.5,
                        textAlign: "center",
                        background: `linear-gradient(135deg, ${GREEN} 0%, #43a047 100%)`,
                        boxShadow: "0 4px 14px rgba(46,125,50,0.25)",
                    }}
                >
                    <Link to="/admin" style={{ display: "block" }}>
                        <Box
                            component="img"
                            src={logo}
                            alt="Low Carbon Logo"
                            sx={{
                                width: "70%",
                                height: "auto",
                                display: "block",
                                mx: "auto",
                                cursor: "pointer",
                                transition: "transform 0.25s ease",
                                "&:hover": { transform: "scale(1.04)" },
                            }}
                        />
                    </Link>
                </Box>


                {/* เมนูหลัก */}
                <Box sx={{ overflowY: "auto", px: 1.5, py: 2, flex: 1 }}>
                    {/* เพิ่มเส้นทาง */}
                    {role === "admin" && (
                        <>
                            <Accordion disableGutters sx={groupSx} defaultExpanded>
                                <AccordionSummary expandIcon={<ExpandMoreIcon fontSize="small" />} sx={groupSummarySx}>
                                    <GroupHeader icon={<PostAdd />} label="เพิ่มข้อมูล" />
                                </AccordionSummary>
                                <AccordionDetails sx={{ p: 0, pb: 1 }}>
                                    <List dense disablePadding>
                                        <Item itemKey="addRouteDistrictName" icon={<LocationCity />} label="เพิ่มชื่ออำเภอ" />
                                        <Item itemKey="addRouteDistrictVideo" icon={<VideoLibrary />} label="เพิ่มวิดีโออำเภอ" />
                                        <Item itemKey="addLanguage" icon={<Translate />} label="เพิ่มภาษา" />
                                        <Item itemKey="addFuel" icon={<LocalGasStation />} label="เพิ่มน้ำมัน" />
                                        {/* <Item itemKey="addvehicleEfficiency" icon={<DirectionsCar />} label="เพิ่มยานพาหนะ" /> */}
                                        <Item itemKey="addtravelDataWithVehicles" icon={<DirectionsBus />} label="เพิ่มข้อมูลการเดินทางแบบใหม่" />
                                    </List>
                                </AccordionDetails>
                            </Accordion>
                            {/* การแก้ไขข้อมูล */}
                            <Accordion disableGutters sx={groupSx} defaultExpanded>
                                <AccordionSummary expandIcon={<ExpandMoreIcon fontSize="small" />} sx={groupSummarySx}>
                                    <GroupHeader icon={<EditNote />} label="แก้ไขข้อมูล" />
                                </AccordionSummary>
                                <AccordionDetails sx={{ p: 0, pb: 1 }}>
                                    <List dense disablePadding>
                                        <Item itemKey="editimagesandvdo" icon={<Panorama />} label="แก้ไขรูปภาพแบรนเนอร์จังหวัด" />
                                        <Item itemKey="editimagebranner" icon={<Image />} label="แก้ไขรูปภาพแบรนเนอร์เส้นทาง" />
                                        <Item itemKey="editimageinfographic" icon={<Insights />} label="แก้ไขรูปภาพอินโฟกราฟฟิก" />
                                        <Item itemKey="editimagedetailplace" icon={<PhotoLibrary />} label="แก้ไขรูปภาพรายละเอียดสถานที่" />
                                    </List>
                                </AccordionDetails>
                            </Accordion>
                            {/* เพิ่มเส้นทาง */}
                            <Accordion disableGutters sx={groupSx} defaultExpanded>
                                <AccordionSummary expandIcon={<ExpandMoreIcon fontSize="small" />} sx={groupSummarySx}>
                                    <GroupHeader icon={<Route />} label="เพิ่มเส้นทาง (คำนวณ Co2e)" />
                                </AccordionSummary>
                                <AccordionDetails sx={{ p: 0, pb: 1 }}>
                                    <List dense disablePadding>
                                        <Item itemKey="addRouteName" icon={<AltRoute />} label="เพิ่มชื่อ Route" />
                                        <Item itemKey="addRouteMap" icon={<Map />} label="เพิ่มแผนที่ Route" />
                                        <Item itemKey="addRouteDetail" icon={<Info />} label="เพิ่มรายละเอียด Route" />
                                    </List>
                                </AccordionDetails>
                            </Accordion>
                            {/* เพิ่มสถานที่ */}

                            <Accordion disableGutters sx={groupSx} defaultExpanded>
                                <AccordionSummary expandIcon={<ExpandMoreIcon fontSize="small" />} sx={groupSummarySx}>
                                    <GroupHeader icon={<AddLocationAlt />} label="เพิ่มสถานที่" />
                                </AccordionSummary>
                                <AccordionDetails sx={{ p: 0, pb: 1 }}>
                                    <List dense disablePadding>
                                        <Item itemKey="touristPlace" icon={<Place />} label="เพิ่มสถานที่ท่องเที่ยว" />
                                        <Item itemKey="homestay" icon={<Hotel />} label="เพิ่มที่พัก" />
                                        <Item itemKey="restaurant" icon={<Restaurant />} label="เพิ่มร้านอาหาร" />
                                        <Item itemKey="gift_shop" icon={<ShoppingBag />} label="เพิ่มร้านของที่ระลึก" />
                                        <Item itemKey="communityProduct" icon={<LocalOffer />} label="เพิ่มผลิตภัณฑ์ชุมชน" />
                                    </List>
                                </AccordionDetails>
                            </Accordion>

                            {/* ตั้งค่า */}
                            <Accordion disableGutters sx={groupSx} defaultExpanded>
                                <AccordionSummary expandIcon={<ExpandMoreIcon fontSize="small" />} sx={groupSummarySx}>
                                    <GroupHeader icon={<Tune />} label="ตั้งค่าเมนู" />
                                </AccordionSummary>
                                <AccordionDetails sx={{ p: 0, pb: 1 }}>
                                    <List dense disablePadding>
                                        <Item itemKey="addTravelType" icon={<Image />} label="เพิ่มรูปแบบการท่องเที่ยว" />
                                    </List>
                                </AccordionDetails>
                            </Accordion>
                        </>
                    )}
                </Box>
            </Box>

            {/* ปุ่มออกจากระบบด้านล่าง */}
            <Box sx={{ p: 2, borderTop: "1px solid #eef2ea" }}>
                <Button
                    variant="outlined"
                    color="error"
                    fullWidth
                    startIcon={<Logout />}
                    sx={{
                        py: 1,
                        borderRadius: 3,
                        fontWeight: 700,
                        bgcolor: "#fff5f5",
                        borderColor: "#f5c2c2",
                        "&:hover": { bgcolor: "#ffe9e9", borderColor: "#e57373" },
                    }}
                    onClick={handleLogout}
                >
                    ออกจากระบบ
                </Button>
            </Box>
        </Drawer>
    );
}

export default AdminSideBar
